import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cdab43d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "myContainer",
  class: "localcontainer",
  style: {"display":"flex","margin-top":"85px","height":"calc(100vh - 140px)","background-color":"#f2f4f8"}
}
const _hoisted_2 = {
  ref: "left",
  class: "left",
  style: {"flex-grow":"1","color":"rgba(0, 0, 0, 0.88)","min-width":"400px","margin-left":"20px","width":"60%"}
}
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = { style: {"margin-left":"5px","width":"90px"} }
const _hoisted_5 = {
  id: "container",
  style: {"overflow":"auto","height":"calc(100% - 60px)"}
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  ref: "right",
  class: "right",
  style: {"height":"100%","width":"40%","box-sizing":"border-box","flex-shrink":"0"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","padding-left":"10px"} }, "checklist", -1))
const _hoisted_9 = { class: "zoomable-div" }
const _hoisted_10 = { style: {"font-weight":"bold","font-size":"22px","padding-bottom":"10px","padding-top":"10px"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  style: {"color":"red","font-size":"14px","position":"relative"}
}
const _hoisted_13 = { style: {"border":"1px dashed red","padding":"5px"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center","height":"40px","font-size":"13px"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { style: {"display":"flex","align-items":"center","height":"40px"} }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_ZoomIn = _resolveComponent("ZoomIn")!
  const _component_ZoomOut = _resolveComponent("ZoomOut")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_Notebook = _resolveComponent("Notebook")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_info_filled = _resolveComponent("info-filled")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_row, {
          justify: "end",
          align: "middle",
          class: "control-bar",
          style: {"border-right":"1px solid #dcdcdc"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_input, {
                    placeholder: "搜索",
                    modelValue: _ctx.searchQuery,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentMatchIndex + 1) + "/" + _toDisplayString(_ctx.matches.length), 1),
                  _createVNode(_component_el_icon, {
                    size: 24,
                    onClick: _ctx.prevMatch,
                    style: {"vertical-align":"middle","cursor":"pointer"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowUp)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_icon, {
                    size: 24,
                    onClick: _ctx.nextMatch,
                    style: {"vertical-align":"middle","margin-left":"5px","cursor":"pointer"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowDown)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  size: 30,
                  onClick: _ctx.zoomIn,
                  style: {"vertical-align":"middle","cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ZoomIn)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_icon, {
                  size: 30,
                  onClick: _ctx.zoomOut,
                  style: {"margin-left":"5px","vertical-align":"middle","cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ZoomOut)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            style: _normalizeStyle([{ transform: `scale(${_ctx.scale})`, transformOrigin: _ctx.origin }, {"width":"auto"}]),
            class: "zoomable-div"
          }, [
            _createElementVNode("pre", {
              style: {"text-align":"left","padding":"10px","white-space":"pre-wrap"},
              innerHTML: _ctx.highlightedText
            }, null, 8, _hoisted_6)
          ], 4)
        ])
      ], 512),
      _createElementVNode("div", {
        ref: "divider",
        class: "divider",
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args)))
      }, null, 544),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_row, {
          justify: "space-between",
          align: "middle",
          class: "control-bar"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { onClick: _ctx.downloadWord }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_scrollbar, {
          class: "text-viewer",
          always: "",
          style: {"background-color":"white"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionList, (question, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: _normalizeStyle([{
                backgroundColor:
                  _ctx.answers[index]?.double_check_answer_output?.Judgment === 'No'
                    ? '#f2086724'
                    : '#24e81438',
              }, {"border-bottom":"1px solid #dcdcdc","text-align":"left","padding-left":"10px","padding-right":"10px"}])
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(question.serial ? question.serial : index + 1) + "." + _toDisplayString(question.question) + "? ", 1),
                  (_ctx.answers.length > index)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.answers[index].final_answer_output.Judgment) + "." + _toDisplayString(_ctx.answers[index].final_answer_output.Response), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (index in _ctx.commentHash)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_el_popconfirm, {
                          "confirm-button-text": "Yes",
                          "cancel-button-text": "No",
                          title: "Are you sure to delete this?",
                          onConfirm: ($event: any) => (_ctx.confirmDeleteComment(index)),
                          width: "250px"
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_el_icon, { style: {"margin-left":"auto","position":"absolute","right":"5px","bottom":"5px","cursor":"pointer"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"]),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.commentHash[index].reported) + "." + _toDisplayString(_ctx.commentHash[index].content), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_el_icon, { style: {"margin-right":"5px","cursor":"pointer"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Notebook)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers[
                    index
                  ]?.question_selected_paragraphs
                    .slice(0, 3)
                    .sort((a, b) => a - b), (identifier, identifierIndex) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass(["num-tag", [
                    'num-tag',
                    {
                      active:
                        _ctx.selectIdentifier == index + '_' + -1 + '_' + identifier,
                    },
                  ]]),
                        onClick: ($event: any) => (_ctx.toggleClick(index, -1, identifier)),
                        key: identifierIndex
                      }, _toDisplayString(identifier), 11, _hoisted_15))
                    }), 128)),
                    _createVNode(_component_el_icon, {
                      style: {"cursor":"pointer","margin-left":"auto","margin-right":"20px"},
                      onClick: ($event: any) => (_ctx.editComment(index))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Edit)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _createVNode(_component_el_collapse, { accordion: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse_item, { name: "1" }, {
                        title: _withCtx(() => [
                          _createTextVNode(" Subquestion"),
                          _createVNode(_component_el_icon, { class: "header-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_info_filled)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (_ctx.answers.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subquestion_list[index], (subquestion, subindex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    style: _normalizeStyle([{
                        backgroundColor:
                          _ctx.answers[index]?.history_score_output[subindex]
                            ?.Judgment == 'Yes'
                            ? '#24e81438'
                            : '#f2086724',
                      }, {"padding":"10px"}]),
                                    key: subindex
                                  }, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("h4", null, _toDisplayString(subindex + 1) + "." + _toDisplayString(subquestion), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createTextVNode(_toDisplayString(_ctx.answers[index]?.history_score_output[subindex]
                            ?.Judgment == "Yes"
                            ? "Reported"
                            : "No reported"), 1),
                                      _hoisted_17,
                                      _createTextVNode(_toDisplayString(_ctx.answers[index]?.history_score_output[subindex]
                            ?.Response), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_el_icon, { style: {"margin-right":"5px","cursor":"pointer"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Notebook)
                                        ]),
                                        _: 1
                                      }),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers[index]
                            ?.history_instruction_selected_paragraphs[subindex]
                            ?.Selected_paragraph_identifiers, (identifier, identifierIndex) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          class: _normalizeClass(["num-tag", [
                            'num-tag',
                            {
                              active:
                                _ctx.selectIdentifier ==
                                index + '_' + subindex + '_' + identifier,
                            },
                          ]]),
                                          onClick: ($event: any) => (_ctx.toggleClick(index, subindex, identifier)),
                                          key: identifierIndex
                                        }, _toDisplayString(identifier), 11, _hoisted_19))
                                      }), 128))
                                    ])
                                  ], 4))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ], 4))
              }), 128))
            ])
          ]),
          _: 1
        })
      ], 512)
    ], 512),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: "FeedBack",
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.confirmComment
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirm ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { model: _ctx.editform }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Reported",
              "label-width": "80px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.editform.reported,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editform.reported) = $event)),
                  placeholder: "Please select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Yes",
                      value: "Yes"
                    }),
                    _createVNode(_component_el_option, {
                      label: "No",
                      value: "No"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Content",
              "label-width": "80px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.editform.content,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editform.content) = $event)),
                  autocomplete: "off",
                  type: "textarea",
                  rows: 5
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}